import React, { useMemo } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { Popover, List, Icon } from "antd";
import { GetMeetingListItemData } from "../../../../service";
import useModalHandler from "../../../../../../../Utils/v2/useModalHandler";
import PreviewSourceModal from "../../../../../../../components/PreviewSourceModal";
import { FILETYPE_LIST } from "../../../../../../../API/teams";
import { ListProps } from "../../../../../../../components/PreviewSourceModal/servers";
import useDeviceType from "../../../../../../../Utils/useDeviceType";

interface Props {
    item: GetMeetingListItemData;
    reload: () => void;
}
const Index = ({ item, reload }: Props) => {
    const { isPC } = useDeviceType();

    const content = useMemo(() => {
        return (
            <List size="small" className={style.list}>
                {item.recording.map(RecordingItem => (
                    <List.Item
                        key={RecordingItem.id}
                        actions={[
                            <Icon
                                type="eye"
                                className={style.icon}
                                onClick={() =>
                                    onPrev(parseInt(RecordingItem.id))
                                }
                            />
                        ]}>
                        <List.Item.Meta title={RecordingItem.name} />
                    </List.Item>
                ))}
            </List>
        );
    }, [item.recording, item.meetingId]);

    const prevModal = useModalHandler(PreviewSourceModal);

    function onPrev(id: number) {
        prevModal.setPayload(id);
        const lists: ListProps[] = item.recording.map(item => {
            return {
                id: parseInt(item.id),
                fileType: item.name?.split(".").pop() || "",
                fileUrl: item.fileKey,
                fileName: item.name
            };
        });
        prevModal.setList(lists);
        prevModal.open();
    }

    return (
        <div className={style.root}>
            {item.recording.length > 0 && isPC && (
                <Popover
                    title="回放列表"
                    placement="bottomLeft"
                    content={content}>
                    <span className={style.cur}>
                        [已关联 {item.recording.length} 个录屏]
                    </span>
                </Popover>
            )}
            {!isPC && (
                <p
                    className={style.prev}
                    onClick={() => onPrev(parseInt(item.recording[0].id))}>
                    点我预览回放
                </p>
            )}
            <div className={classNames(style.info)}>会议时间：{item.time}</div>

            {prevModal.render(
                <PreviewSourceModal
                    zIndex={1100}
                    FILETYPE_LIST={FILETYPE_LIST}
                />
            )}
        </div>
    );
};

export default Index;
